import createAPI from '../../common/helpers/create-api'

export default function addTimePicker (Vue, TimePicker) {
  createAPI(Vue, TimePicker, ['select', 'cancel', 'change'])
}



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/modules/time-picker/api.js